@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'offline') {
  <tyt-offline message="You need an Internet connection to update your newsletter preferences."></tyt-offline>
}
@if (state === 'ready') {
  <div>
    @if (user) {
      <div class="communication-preference-container">
        <app-form #form action="/cancelMembership" [handler]="this" class="form-fields">
          <error-message></error-message>
          @if (submitting) {
            <div style="text-align:center;">
              <h1>Saving your preferences...</h1>
              <app-spinner class="inline"></app-spinner>
            </div>
          }
          @if (!submitting && submitSuccess) {
            <div>
              @if (submitSuccess) {
                <div class="alert alert-success">
                  Your newsletter preferences have been saved!
                </div>
              }
              <div class="submit-buttons">
                <a mat-raised-button color="primary" routerLink="/home">Done</a>
                <a mat-raised-button color="primary" class="btn-cancel" (click)="submitSuccess = false">Edit Again</a>
              </div>
            </div>
          }
          @if (!submitting && !submitSuccess) {
            <div>
              <p>
                You will receive your chosen newsletters at the address associated with your TYT account, which is
                <em class="email">{{user.email}}</em>
              </p>
              <div class="content-box">
                @for (pref of emailPrefs; track pref) {
                  <div>
                    <mat-checkbox name="{{pref.provider_id}}" (change)="submitSuccess = false" [(ngModel)]="pref.allowed">{{pref.label}}</mat-checkbox>
                  </div>
                }
              </div>
              @if (submitSuccess) {
                <div class="alert alert-success">
                  Your newsletter preferences have been saved!
                </div>
              }
              <div class="submit-buttons">
                <button mat-raised-button color="primary">Save Changes</button>
                <a mat-button routerLink="/settings">Cancel</a>
              </div>
            </div>
          }
        </app-form>
      </div>
    }
  </div>
}